import type { ServicesClientsOrdwayPaymentMethod } from '@customerio/hydra-ui-api';
import type { PaymentCard } from '../types';

/**
 * The four fields the card readout reads. The wire model carries a good deal
 * more (billing address, gateway ids, timestamps); naming what this transform
 * actually needs lets a caller — the boot payload or a test — supply exactly
 * that instead of a whole payment method.
 */
type OrdwayPaymentCardSource = Pick<
  ServicesClientsOrdwayPaymentMethod,
  'type' | 'account_number' | 'expiry' | 'account_holder_name'
>;

/**
 * Map an Ordway payment method into the shared {@link PaymentCard} shape: the account number is
 * sliced to its last four and the payment type is lowercased into a brand, matching how the Ember
 * `cardDetails` getter and `credit-card/card-details` component normalized Ordway card data.
 */
export function ordwayPaymentToPaymentCard(payment: OrdwayPaymentCardSource): PaymentCard {
  return {
    brand: payment.type.toLowerCase(),
    last4: payment.account_number.slice(-4),
    expiry: payment.expiry,
    ownerName: payment.account_holder_name,
  };
}
